
export const RULES = {

    REQUIRED_FIELD: (fieldName = 'This field')=> [v => !!v || `${fieldName} is required`],
    PHONE_NUMBER : [ v => !v || /^\(?\d{3}\)?[\s\-]?\d{3}[\s\-]?\d{4}$/.test(v) || 'Must be 10 digits'],
    CITY_NAME: [v => !v || /^[a-zA-Z ]+$/.test(v) || 'City name must contain only letters'],
    ZIP_CODE: [v => !v || /^\d{5}$/.test(v) || 'Zip code must be 5 digits'],
    EMAIL: [v => !v || /^.+@\w+\.\w{2,4}$/.test(v) || 'Email must be valid'],
    MAX_SIZE: (max_size)=> [v => !v || v.size < max_size || `Total file size should be less than ${max_size} MB!`],
 
};